export const INSTITUTION_TYPES = {
  coaching: {
    label:'Coaching Center', icon:'🎯', studentLabel:'Student', staffLabel:'Teacher',
    courseLabel:'Course', groupLabel:'Batch', branchLabel:'Branch', semesterLabel:'Term', sectionLabel:'Batch',
    supportsCarryForward:false, academicMode:'course_batch',
    modules:['admissions','academics','attendance','learning','exams','fees','finance','documents','live','website','communication','reports','gatepass','transport']
  },
  school: {
    label:'School', icon:'🏫', studentLabel:'Student', staffLabel:'Teacher',
    courseLabel:'Class', groupLabel:'Section', branchLabel:'Campus', semesterLabel:'Term', sectionLabel:'Section',
    supportsCarryForward:true, academicMode:'class_section',
    modules:['admissions','academics','attendance','learning','exams','fees','finance','documents','gatepass','transport','website','communication','reports']
  },
  college: {
    label:'College', icon:'🏛️', studentLabel:'Student', staffLabel:'Faculty',
    courseLabel:'Course', groupLabel:'Branch / Department', branchLabel:'Branch / Department', semesterLabel:'Semester', sectionLabel:'Section / Batch',
    supportsCarryForward:true, academicMode:'course_branch_semester',
    modules:['admissions','academics','attendance','learning','exams','fees','finance','documents','gatepass','transport','live','website','communication','reports']
  },
  nursing: {
    label:'Nursing College', icon:'🩺', studentLabel:'Student', staffLabel:'Faculty',
    courseLabel:'Program', groupLabel:'Branch / Semester', branchLabel:'Branch / Department', semesterLabel:'Semester', sectionLabel:'Batch',
    supportsCarryForward:true, academicMode:'course_branch_semester',
    modules:['admissions','academics','attendance','learning','exams','fees','finance','documents','clinical','gatepass','transport','live','website','communication','reports']
  },
  academy: {
    label:'Academy / Training Institute', icon:'🏅', studentLabel:'Learner', staffLabel:'Trainer',
    courseLabel:'Program', groupLabel:'Batch', branchLabel:'Branch', semesterLabel:'Level', sectionLabel:'Batch',
    supportsCarryForward:false, academicMode:'course_batch',
    modules:['admissions','academics','attendance','learning','exams','fees','finance','documents','live','website','communication','reports','gatepass','transport']
  },
};

export const INSTITUTION_TYPE_OPTIONS = Object.entries(INSTITUTION_TYPES).map(([value,x])=>({value,label:x.label}));

export function normalizeInstitutionType(value='') {
  const v=String(value).toLowerCase();
  if(v.includes('nursing')) return 'nursing';
  if(v.includes('school')) return 'school';
  if(v.includes('college')) return 'college';
  if(v.includes('academy')||v.includes('training')) return 'academy';
  return 'coaching';
}

export function getInstitutionType(value){
  return INSTITUTION_TYPES[normalizeInstitutionType(value)] || INSTITUTION_TYPES.coaching;
}

export function getDefaultLabels(value){
  const type=getInstitutionType(value);
  return {
    student:type.studentLabel,
    students:`${type.studentLabel}s`,
    teacher:type.staffLabel,
    teachers:type.staffLabel==='Faculty'?'Faculty':(type.staffLabel.endsWith('y')?`${type.staffLabel.slice(0,-1)}ies`:`${type.staffLabel}s`),
    course:type.courseLabel,
    courses:`${type.courseLabel}s`,
    section:type.sectionLabel,
    sections:`${type.sectionLabel}s`,
    batch:type.groupLabel,
    batches:`${type.groupLabel}s`,
    branch:type.branchLabel,
    branches:`${type.branchLabel}s`,
    semester:type.semesterLabel,
    semesters:`${type.semesterLabel}s`,
    admission:'Admission',
    admissionNo:'Admission No.',
    enrollmentNo:'Enrollment No.',
    rollNo:'Roll No.',
    session:'Academic Session',
    parent:'Parent / Guardian',
    fee:'Fee',
    transport:'Transport',
    gatePass:'Gate Pass',
    certificate:'Certificate',
  };
}
